/* Back2Africa 2026 — storefront behavior
   Cart state always comes back from Shopify (Section Rendering API), never from
   local guesses, so tier prices and the freight bar stay authoritative. */
(function () {
  'use strict';

  var root = document.documentElement;
  var money = function (cents) {
    var f = (window.B2A && window.B2A.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  };

  function on(el, evt, sel, fn) {
    el.addEventListener(evt, function (e) {
      var t = e.target.closest(sel);
      if (t && el.contains(t)) fn(e, t);
    });
  }

  /* ------------------------------------------------------------------ nav */
  function initNav() {
    var burger = document.querySelector('[data-burger]');
    var drawer = document.querySelector('[data-mobile-nav]');
    if (!burger || !drawer) return;

    var open = function () {
      drawer.classList.add('is-open');
      root.style.overflow = 'hidden';
      burger.setAttribute('aria-expanded', 'true');
    };
    var close = function () {
      drawer.classList.remove('is-open');
      root.style.overflow = '';
      burger.setAttribute('aria-expanded', 'false');
    };

    burger.addEventListener('click', open);
    on(drawer, 'click', '[data-mobile-close], .mobile-nav__scrim', close);
    on(drawer, 'click', '.mobile-nav__toggle', function (e, btn) {
      btn.closest('.mobile-nav__group').classList.toggle('is-open');
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* --------------------------------------------------------------- slider */
  function initSlider(el) {
    var slides = el.querySelectorAll('[data-slide]');
    var dots = el.querySelectorAll('[data-dot]');
    if (slides.length < 1) return;

    var i = 0;
    var interval = parseInt(el.dataset.interval || '7000', 10);
    var autoplay = el.dataset.autoplay !== 'false' && slides.length > 1;
    var timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) slides[s].classList.toggle('is-active', s === i);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      var counter = el.querySelector('[data-slide-counter]');
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    function start() { if (autoplay) { stop(); timer = setInterval(function () { show(i + 1); }, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    on(el, 'click', '[data-dot]', function (e, b) { show(parseInt(b.dataset.dot, 10)); start(); });
    on(el, 'click', '[data-slide-prev]', function () { show(i - 1); start(); });
    on(el, 'click', '[data-slide-next]', function () { show(i + 1); start(); });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);

    show(0);
    start();
  }

  /* ------------------------------------------------------------ accordion */
  function initAccordions(scope) {
    on(scope, 'click', '.accordion__toggle', function (e, btn) {
      var item = btn.closest('.accordion__item');
      var isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      var sign = btn.querySelector('.accordion__sign');
      if (sign) sign.textContent = isOpen ? '−' : '+';
    });

    /* Deep links and in-page anchors should open the panel they point at. */
    if (window.location.hash) {
      var target = scope.querySelector(window.location.hash + '.accordion__panel');
      if (target) {
        var host = target.closest('.accordion__item');
        if (host) {
          host.classList.add('is-open');
          var t = host.querySelector('.accordion__toggle');
          if (t) t.setAttribute('aria-expanded', 'true');
        }
      }
    }
  }

  function announce(msg) {
    var live = document.querySelector('[data-cart-live]');
    if (live) live.textContent = msg;
  }

  /* --------------------------------------------------------- tier selector
     Each pill IS a variant. Selecting one rewrites the hidden id input, the
     headline price and the per-unit line. No change events are dispatched —
     the form reads input[name=id] directly on submit. */
  function initTiers(scope) {
    on(scope, 'click', '.tier', function (e, btn) {
      if (btn.hasAttribute('disabled')) return;
      var form = btn.closest('[data-buy-form]');
      if (!form) return;
      e.preventDefault();

      form.querySelectorAll('.tier').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = btn.dataset.variantId;

      var priceEl = form.querySelector('[data-price]');
      var eachEl = form.querySelector('[data-each]');
      var atc = form.querySelector('[data-atc]');
      var qty = parseInt((form.querySelector('[data-qty-input]') || {}).value || '1', 10);

      if (priceEl) priceEl.textContent = money(parseInt(btn.dataset.price, 10) * qty);
      if (eachEl) eachEl.textContent = btn.dataset.each || '';
      if (atc) {
        var available = btn.dataset.available === 'true';
        atc.disabled = !available;
        atc.textContent = available ? (atc.dataset.labelAdd || 'Add to bag') : (atc.dataset.labelSold || 'Sold out');
      }
      /* Choosing a pack is what unlocks the sticky bar's add action. Changing
         quantity does not, since no pack has been picked yet. */
      var bar = document.querySelector('[data-sticky-atc]');
      if (bar) bar.dataset.stickyMode = 'add';

      updateLineTotal(form);
      syncStickyPrice(form);
    });
  }

  function updateLineTotal(form) {
    var active = form.querySelector('.tier.is-active') || form.querySelector('.tier');
    var priceEl = form.querySelector('[data-price]');
    var qtyInput = form.querySelector('[data-qty-input]');
    if (!active || !priceEl || !qtyInput) return;
    var qty = Math.max(1, parseInt(qtyInput.value || '1', 10));
    priceEl.textContent = money(parseInt(active.dataset.price, 10) * qty);
    syncStickyPrice(form);
  }

  function initQty(scope) {
    on(scope, 'click', '[data-qty-step]', function (e, btn) {
      var wrap = btn.closest('.qty');
      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var next = Math.max(1, (parseInt(input.value || '1', 10)) + parseInt(btn.dataset.qtyStep, 10));
      input.value = next;
      var form = btn.closest('[data-buy-form]');
      if (form) updateLineTotal(form);
    });
    on(scope, 'input', '[data-qty-input]', function (e, input) {
      var form = input.closest('[data-buy-form]');
      if (form) updateLineTotal(form);
    });
  }

  /* ----------------------------------------------------------- cart drawer */
  var Cart = {
    lastFocus: null,

    el: function () { return document.querySelector('[data-cart-drawer]'); },

    open: function () {
      var d = Cart.el();
      if (!d) return;
      Cart.lastFocus = document.activeElement;
      d.classList.add('is-open');
      root.style.overflow = 'hidden';
      /* Move focus into the drawer so keyboard and screen-reader users are
         actually taken there, and Tab stays inside it. */
      var first = d.querySelector('[data-cart-close], button, a[href]');
      if (first) first.focus();
      document.addEventListener('keydown', Cart.trap, true);
    },

    close: function () {
      var d = Cart.el();
      if (!d) return;
      d.classList.remove('is-open');
      root.style.overflow = '';
      document.removeEventListener('keydown', Cart.trap, true);
      if (Cart.lastFocus && Cart.lastFocus.focus) Cart.lastFocus.focus();
    },

    trap: function (e) {
      if (e.key !== 'Tab') return;
      var d = Cart.el();
      if (!d || !d.classList.contains('is-open')) return;
      var f = d.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    },

    refresh: function (thenOpen) {
      return fetch(window.Shopify.routes.root + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-cart-drawer]');
          var current = Cart.el();
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen || thenOpen) Cart.open();
          }
          Cart.syncChrome(parsed);
          Cart.loadRecommendations();
        })
        .catch(function () { window.location.href = window.Shopify.routes.root + 'cart'; });
    },

    /* header count + the freight bar that lives under the nav */
    syncChrome: function (parsed) {
      var freshCount = parsed.querySelector('[data-cart-count-source]');
      var count = freshCount ? freshCount.dataset.cartCountSource : null;
      document.querySelectorAll('[data-cart-count]').forEach(function (n) {
        if (count !== null) n.textContent = count;
      });
      document.querySelectorAll('[data-cart-toggle]').forEach(function (n) {
        n.dataset.filled = (count && count !== '0') ? 'true' : 'false';
      });

      var freshBar = parsed.querySelector('[data-freight-source]');
      var bar = document.querySelector('[data-freight-bar]');
      if (bar && freshBar) {
        bar.innerHTML = freshBar.innerHTML;
        bar.hidden = freshBar.dataset.freightSource === 'empty';
      }
    },

    /* Swap the curated suggestions for Shopify's own complementary
       recommendations when it has some. Silent no-op on failure: the curated
       list is already rendered, so the drawer never ends up empty. */
    loadRecommendations: function () {
      var box = document.querySelector('[data-upsell]');
      if (!box) return;
      var productId = box.dataset.firstProduct;
      var list = box.querySelector('[data-upsell-list]');
      if (!productId || !list) return;

      /* Complementary first: those are the pairings a merchant sets by hand in
         Search & Discovery and they are the real "bought together". This store
         has none configured yet, so fall through to Shopify's automatic related
         products, and to the curated collection if both come back empty. */
      var base = window.Shopify.routes.root + 'recommendations/products'
        + '?section_id=cart-upsell&limit=3&product_id=' + productId + '&intent=';

      var rowsFrom = function (html) {
        if (!html) return [];
        return new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.upsell__row');
      };
      var paint = function (rows) {
        list.innerHTML = '';
        Array.prototype.forEach.call(rows, function (row) { list.appendChild(row); });
      };

      fetch(base + 'complementary')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          var rows = rowsFrom(html);
          if (rows.length) { paint(rows); return null; }
          return fetch(base + 'related').then(function (r) { return r.ok ? r.text() : null; });
        })
        .then(function (html) {
          if (!html) return;
          var rows = rowsFrom(html);
          if (rows.length) paint(rows);
        })
        .catch(function () { /* curated list stays */ });
    },

    add: function (form) {
      var btn = form.querySelector('[data-atc]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(form.querySelector('input[name="id"]').value, 10),
            quantity: parseInt((form.querySelector('[data-qty-input]') || { value: 1 }).value, 10) || 1
          }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          announce((data.items && data.items[0] ? data.items[0].title : 'Item') + ' added to your bag.');
          return Cart.refresh(true);
        })
        .catch(function (err) { alert(err.message || 'Could not add to bag.'); })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    },

    change: function (key, quantity) {
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function () { return Cart.refresh(false); });
    }
  };

  function initCart() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) { e.preventDefault(); Cart.refresh(true); return; }
      if (e.target.closest('[data-cart-close]') || e.target.closest('.drawer__scrim')) { Cart.close(); return; }

      var step = e.target.closest('[data-line-step]');
      if (step) {
        e.preventDefault();
        Cart.change(step.dataset.lineKey, parseInt(step.dataset.lineStep, 10));
        return;
      }
      var remove = e.target.closest('[data-line-remove]');
      if (remove) { e.preventDefault(); Cart.change(remove.dataset.lineKey, 0); }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-buy-form]');
      if (!form || form.dataset.noAjax === 'true') return;
      e.preventDefault();
      Cart.add(form);
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
  }

  /* ------------------------------------------------------------- gallery */
  function initGallery(scope) {
    on(scope, 'click', '[data-thumb]', function (e, btn) {
      var gallery = btn.closest('[data-gallery]');
      var main = gallery.querySelector('[data-gallery-main]');
      if (main) main.src = btn.dataset.thumb;

      /* keep the zoom target in step with the thumbnail just chosen */
      var opener = gallery.querySelector('[data-zoom-open]');
      if (opener && btn.dataset.thumbFull) opener.dataset.zoomSrc = btn.dataset.thumbFull;

      gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  }

  /* ---------------------------------------------------- full-size viewer */
  function initZoom() {
    var box = document.querySelector('[data-zoom]');
    if (!box) return;
    var img = box.querySelector('[data-zoom-img]');
    var opener = null;

    function open(src, from) {
      img.src = src;
      box.hidden = false;
      root.style.overflow = 'hidden';
      opener = from;
      var close = box.querySelector('[data-zoom-close]');
      if (close) close.focus();
    }
    function close() {
      box.hidden = true;
      root.style.overflow = '';
      img.src = '';
      if (opener && opener.focus) opener.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-zoom-open]');
      if (trigger) { e.preventDefault(); open(trigger.dataset.zoomSrc, trigger); return; }
      if (e.target.closest('[data-zoom-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  }

  /* ---------------------------------------------------- announcement bar
     Desktop shows every item at once; below 860px they would stack, so one
     item is shown at a time and rotated. */
  function initAnnounce() {
    var bar = document.querySelector('[data-announce]');
    if (!bar) return;
    var items = bar.querySelectorAll('.announce__item');
    if (items.length < 2) return;

    var mq = window.matchMedia('(max-width: 860px)');
    var i = 0, timer = null;

    function step() {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }
    function sync() {
      if (timer) { clearInterval(timer); timer = null; }
      for (var n = 0; n < items.length; n++) items[n].classList.remove('is-active');
      if (mq.matches) {
        i = 0;
        items[0].classList.add('is-active');
        timer = setInterval(step, 4000);
      } else {
        for (var m = 0; m < items.length; m++) items[m].classList.add('is-active');
      }
    }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  }

  /* ------------------------------------------------------ sticky buy bar */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var form = document.querySelector('[data-buy-form]');
    if (!bar || !form) return;

    var realAtc = form.querySelector('[data-atc]');
    if (!realAtc) return;

    bar.querySelector('[data-sticky-add]').addEventListener('click', function () {
      /* Multi-pack products start in "choose" mode: send the buyer to the pack
         selector instead of silently adding the smallest pack. */
      if (bar.dataset.stickyMode === 'choose') {
        var tiers = form.querySelector('.tiers');
        var target = tiers || form;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = form.querySelector('.tier:not([disabled])');
        if (first) setTimeout(function () { first.focus(); }, 320);
        return;
      }
      /* Submit the real form so variant + quantity always match the buy box. */
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        /* Only once the real button has scrolled UP out of view — not while it
           is still below the fold on first paint. */
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
      });
    }, { threshold: 0 }).observe(realAtc);
  }

  function syncStickyPrice(form) {
    var bar = document.querySelector('[data-sticky-atc]');
    var price = form.querySelector('[data-price]');
    var sticky = document.querySelector('[data-sticky-price]');
    if (price && sticky) sticky.textContent = price.textContent;

    var atc = form.querySelector('[data-atc]');
    var stickyBtn = document.querySelector('[data-sticky-add]');
    if (atc && stickyBtn) {
      stickyBtn.disabled = atc.disabled;
      stickyBtn.textContent = atc.disabled ? atc.textContent : (stickyBtn.dataset.labelAdd || atc.textContent);
    }
  }

  /* -------------------------------------------------------------- reveal */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('reveal'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (n) { io.observe(n); });
  }

  /* ------------------------------------------------- condensed header
     Adds .header--stuck past the first screenful so the header can shrink.
     Read inside rAF so the scroll listener never forces layout. */
  function initStickyHeader() {
    var header = document.querySelector('.header');
    if (!header) return;
    var ticking = false;
    var THRESHOLD = 120;

    function apply() {
      header.classList.toggle('header--stuck', window.scrollY > THRESHOLD);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }, { passive: true });
    apply();
  }
  function init() {
    initNav();
    initCart();
    initAccordions(document);
    initTiers(document);
    initQty(document);
    initGallery(document);
    initZoom();
    initReveal();
    initAnnounce();
    initStickyAtc();
    initStickyHeader();
    document.querySelectorAll('[data-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* re-init sliders inside sections re-rendered by the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-slider]').forEach(initSlider);
  });

  window.B2ACart = Cart;
})();
